import { useQuery } from 'react-query';

import { getLongestDeletedActivities as queryFn } from 'api/endPoints/getLongestDeletedActivities';

export const useQueryLargestDeletedActivitiesTableData = (params) => {
    return useQuery(['largestDeletedActivitiesTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
